export const EMPTY_VALUE_PLACEHOLDER = "--";